module.exports = __webpack_public_path__ + "assets/icon-grid.c99db035.svg";